import { Platform } from "react-native";
import React, { useEffect, useState } from "react";
import { useAtomValue } from "jotai";
import { cmsDataAtom, externalWebsitesAtom } from "../atoms";
import { nativeNavFromSlug } from "../components/Promotion/Utils";
import { Nav } from "../client/more/externalWebsites";

const useCmsMoreMenu = () => {
  const CmsData = useAtomValue(cmsDataAtom);
  const externalWebsites = useAtomValue(externalWebsitesAtom);
  const [moreMenuItems, setMoreMenuItems] = useState<Nav[]>([]);

  useEffect(() => {
    if (!CmsData) return;
    const menuItems = CmsData?.settings?.navigation_items[Platform.OS]; // extract links for platform
    if (!menuItems) return;
    const formatted: Nav[] = menuItems.map((item) => {
      const { screen: route, paramsObj: params } = nativeNavFromSlug(
        item.location
      );

      if (!route) return; // if no route, don't add to menu, avoid dead links
      return {
        title: item.title,
        route: route,
        params: params,
      };
    });

    setMoreMenuItems([...formatted, ...externalWebsites].filter(Boolean));
  }, [CmsData, externalWebsites]);

  return { moreMenuItems };
};

export default useCmsMoreMenu;
